import React from 'react';
import Select from "react-select";
import { map } from 'lodash'
import {FormGroup, Label} from "reactstrap";

export default function MultiSelect(props) {
    const { value, handleChange, options, placeholder, labelProp, valueProp, label, required, error } = props;
    let selectOptions = [];

    const labelKey = (labelProp) ? labelProp : 'label';
    const valueKey = (valueProp) ? valueProp : 'value';

    const formattedOptions = map(options, option => {
        return {label: option[labelKey], value: option[valueKey]};
    });

    // Handle value - ensure it's an array
    if (value && Array.isArray(value)) {
        selectOptions = formattedOptions.filter(option => 
            value.includes(option.value)
        );
    }

    const handleMultiChange = (selectedOptions) => {
        const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
        handleChange(values);
    };

    return (
        <FormGroup>
            <Label>{label} {required ? '*' : ''}</Label>
            <Select
                className="react-select info"
                classNamePrefix="react-select"
                onChange={handleMultiChange}
                options={formattedOptions}
                placeholder={placeholder || 'Select options...'}
                value={selectOptions}
                isSearchable
                isClearable
                isMulti
                closeMenuOnSelect={false}
            />
            {error ? (
                <span className="text-danger">{error}</span>
            ) : ''}
        </FormGroup>
    );
}
